import React from 'react';
import EventEntry from './EventEntry';

const DateCell = ({ dayData, onEventClick, onDateClick }) => {
  if (!dayData) {
    return <div className="min-h-[80px] md:min-h-[120px] bg-muted/30 rounded-lg" />;
  }

  const { day, date, events, isToday } = dayData;
  const hasEvents = events?.length > 0;
  const visibleEvents = events?.slice(0, 3);
  const overflowCount = events?.length > 3 ? events?.length - 3 : 0;

  const handleCellClick = (e) => {
    if (e?.target === e?.currentTarget) {
      onDateClick(date);
    }
  };

  return (
    <div
      onClick={handleCellClick}
      className={`min-h-[80px] md:min-h-[120px] p-2 rounded-lg border transition-smooth cursor-pointer ${
        isToday
          ? 'bg-primary/5 border-primary shadow-sm'
          : 'bg-card border-border hover:border-primary/30 hover:shadow-sm'
      }`}
    >
      <div className={`text-sm md:text-base font-medium mb-2 ${
        isToday ? 'text-primary' : 'text-foreground'
      }`}>
        {day}
      </div>

      {hasEvents && (
        <div className="space-y-1">
          {visibleEvents?.map((event) => (
            <EventEntry
              key={event?.id}
              event={event}
              onEventClick={onEventClick}
            />
          ))}
          {overflowCount > 0 && (
            <div className="text-xs text-muted-foreground font-medium px-2 py-1">
              +{overflowCount} more
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DateCell;